import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Container = styled.div`
  position: relative;
`

export const CloseIcon = styled.div`
  cursor: pointer;
  color: ${colors.strongGray};
  position: absolute;
  top: -20px;
  right: 1px;
`
export const RowGap = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
`
export const CheckBoxArea = styled.div`
  display: flex;
  flex-direction: column;
  padding: 17px 12.5px;
  grid-template-columns: 1fr 1fr;
  row-gap: 20px;
  border-radius: 12px;
  border: 1px solid ${colors.grayBackground};
`
export const Section = styled.div`
  display: flex;
  gap: 24px;
  margin: 12px 0;
`
export const Area = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: flex-start;
`
export const AreaDateInput = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const DateInput = styled.input`
  width: 100vw;
`

export const AreaLabel = styled.div`
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
  font-size: 19px;
`

export const LabelAndCheckBoxGroup = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
  margin-bottom: 16px;
  width: 100%;
`

export const Input = styled.input`
  width: 100%;
  min-height: 48px;
  border-radius: 12px;
  background-color: '#F2F3F5';
  border: 1px solid ${colors.softGray};
  &:focus {
    border-color: ${colors.primary};
    outline: none;
  }
  ::placeholder {
    color: ${colors.strongGray};
  }
  font-family: inherit;
  color: ${colors.titleStrongBlack};
  font-size: 16px;
  box-sizing: border-box;
  padding-left: 16px;
  vertical-align: baseline;

  &[type=number] {
    -moz-appearance: textfield;
  }
  /* Remove the arrows for number input in Webkit browsers */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`

export const SearchContainer = styled.div`
`
